var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "form",
    {
      staticClass: "new-auto-invoice",
      on: {
        submit: function($event) {
          $event.preventDefault()
          return _vm.onSubmit($event)
        }
      }
    },
    [
      _c("div", { staticClass: "columns is-multiline" }, [
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            _c("VoucherDetails", {
              attrs: { "is-loading": _vm.loading, inline: true }
            })
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12" },
          [_c("Concepts", { attrs: { "is-loading": _vm.loading } })],
          1
        ),
        _c(
          "div",
          { staticClass: "column is-12" },
          [
            _c("CfdisRelatedReplacement", {
              attrs: { "replacement-type": "replacementInvoice" }
            })
          ],
          1
        ),
        _c("div", { staticClass: "column is-12 action-buttons" }, [
          _c("div", { staticClass: "field is-grouped" }, [
            _c("p", { staticClass: "control" }, [
              _c(
                "button",
                {
                  staticClass: "button is-success",
                  class: { "is-loading": _vm.loading },
                  attrs: { type: "submit", disabled: _vm.loading }
                },
                [_vm._v("\n            Guardar\n          ")]
              )
            ]),
            _c(
              "p",
              { staticClass: "control" },
              [
                _c(
                  "RouterLink",
                  {
                    staticClass: "button is-danger",
                    class: { "is-loading": _vm.loading },
                    attrs: { disabled: _vm.loading, to: { name: "Home" } }
                  },
                  [_vm._v("\n            Cancelar\n          ")]
                )
              ],
              1
            )
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }